<template>
  <el-container style="height: 100%; border: 1px solid #eee">
    <el-aside width="200px" style="background-color: #545c64">
      <el-menu
        :default-active="active"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="select"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
      <template v-for="item in menus">
        <el-menu-item :index="item.index" :key="item.index">
          <i :class="item.icon"></i>
          <span slot="title">{{item.title}}</span>
        </el-menu-item>
      </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header-content-warp" style="text-align: right; font-size: 12px; background-color: rgb(84, 92, 100);">
        <div class="logo">InflamNat</div>
        <div class="username">
          <!-- <el-avatar class="rt-10" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar> -->
          <span class="rt-10">{{username}}</span>
          <el-button type="primary" @click="logout">logout</el-button>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "navigation",
  data() {
    return {
      username: '',
      userInfo: {},
      active: '/main/data/upsmile',
      menus: [
        {
          index: "/main/data/upsmile",
          icon: "el-icon-document",
          title: "ACT",
        },
        {
          index: "/main/data/uptarget",
          icon: "el-icon-document",
          title: "TARGET",
        },
        // {
        //   index: "/main/data/sendmail",
        //   icon: "el-icon-document",
        //   title: "SENDMAIL",
        // },
      ],
    };
  },
  watch: {
    $route: {
      handler({ fullPath }) {
        let i = this.menus.find(item => {
          return fullPath.includes(item.index); 
        });
        if (i) {
          this.active = i.index;
        } else {
          this.active = fullPath;
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    select(key) {
      console.log(key);
      this.$router.replace({
        path: key,
      });
    },
    logout() {
      this.$http({
        url: '/api/user/logout',
        method: 'get'
      }).then(res => {
        window.location.reload()
      });
    }
  },
  mounted() {
   this.$http({
      url: '/api/getUserName',
      method: 'get'
    }).then(res => {
      this.username = res.data.data;
      if (!this.username) {
        this.$router.push({
          path: '/login'
        });
      }
    });
  }
};
</script>

<style scoped>
  .left {
    height: 100vh;
    background: #555c65;
  }
  .main-warp {
    height: 100%;
  }
  .header-content-warp {
    display: flex;
    justify-content: space-between;
  }
  .logo {
    display: flex;
    align-items: center;
    height: 100%;
    color: #fff;
    font-size: 20px;
  }
  .username {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    color: #fff;
  }
  .rt-10 {
    margin-right: 10px;
  }
</style>